module.exports = __webpack_public_path__ + "media/brands/wangye-51d5f049.png";